import React, {useEffect, useState} from 'react';
import {LoadPanel} from 'devextreme-react/load-panel';

function ComponentLoadPanel(props) {

    const {showLoadPanel, time, message} = props;

    const [textPanel, setTextPanel] = useState('')

    useEffect(() => {
        if (showLoadPanel) {
            setTextPanel(message);
            setTimeout(() => {
                setTextPanel('Espere un momento. . . .')
            }, time)
        } else {
            setTextPanel('')
        }
    }, [message, showLoadPanel, time])

    return (
        <LoadPanel
            shadingColor="rgba(0,0,0,0.2)"
            position={'center'}
            width={'auto'}
            visible={showLoadPanel}
            showIndicator={true}
            shading={true}
            showPane={true}
            closeOnOutsideClick={false}
            message={textPanel}
        />
    )
}

export default ComponentLoadPanel